import React from 'react'

import {
  calcFiveSegmentsRatioAndIndicators,
  findByPath,
  type FiveSegmentCounts,
  type FiveSegmentIndicator,
  toFiveSegmentCounts,
} from '~/utils'

import { type CountColumnKey } from '../utils'

import { useNineSegmentsBrandsData } from './useNineSegmentsBrandsData'
import { useTotalCountsData } from './useTotalCountsData'

type FiveSegmentsBrandData = {
  countColumnKey: CountColumnKey
  brandId: number
  brandName: string
  brandNumber: number
  counts: FiveSegmentCounts
  ratios: FiveSegmentCounts & Record<FiveSegmentIndicator, number>
}

export const useFiveSegmentsBrandsData = (): FiveSegmentsBrandData[] => {
  const nineSegmentsBrandsData = useNineSegmentsBrandsData()
  const totalCountsData = useTotalCountsData()

  return React.useMemo(
    () =>
      nineSegmentsBrandsData.map<FiveSegmentsBrandData>(
        (nineSegmentsBrandData) => {
          const counts = toFiveSegmentCounts(nineSegmentsBrandData.counts)
          const totalCountData = findByPath(
            totalCountsData,
            'countColumnKey',
            nineSegmentsBrandData.countColumnKey,
          )
          const ratios = calcFiveSegmentsRatioAndIndicators(
            counts,
            totalCountData?.count ?? NaN,
          )

          return { ...nineSegmentsBrandData, counts, ratios }
        },
      ),
    [nineSegmentsBrandsData, totalCountsData],
  )
}
